import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';
import { SortDirectionEnum } from '~/utils/enum';
import { cast } from '~/utils/helper';
import type { IPerson, IParamsPerson } from '~/utils/interface/person';

export const SUBJECT_MENU_DISPLAY_LIMIT = 50;

export function buildReportPersonListParams(
  username: string,
  options?: { search?: string; pageSize?: number; sortBy?: string }
): IParamsPerson {
  const search = options?.search?.trim() ?? '';
  return {
    username,
    search,
    sortBy: options?.sortBy ?? '',
    provinceId: '',
    wardId: '',
    startDate: '',
    endDate: '',
    sortOrder: SortDirectionEnum.ASC,
    pageIndex: PAGE_INDEX,
    pageSize: options?.pageSize ?? PAGE_SIZE,
  };
}

export function personRowId(p: IPerson): string {
  return String(p.id ?? '');
}


export function personFullName(p: IPerson): string {
  return cast(p.full_name) || '';
}

export function personCccd(p: IPerson): string {
  return cast(p.cccd) || '';
}

export function personMenuLabel(p: IPerson): string {
  const fullName = personFullName(p);
  const cccd = personCccd(p);
  if (fullName && cccd) return `${fullName} / ${cccd}`;
  return fullName || cccd || '';
}

export function filterPersonsWithLabel(list: IPerson[]): IPerson[] {
  return list.filter((p) => Boolean(personRowId(p)) && Boolean(personMenuLabel(p)));
}

